import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { disputeStatusToApi, PaymentService } from '@galaxy/billing';
import { DisputeStatus } from '@galaxy/billing';
import { map } from 'rxjs/operators';

export interface DisputeStats {
  countRequiresResponse: number;
  countInquiryRequiresResponse: number;
}

@Injectable({
  providedIn: 'root',
})
export class DisputesPageStatsService {
  constructor(private paymentService: PaymentService) {}

  get(merchantId: string): Observable<DisputeStats> {
    const inquiryRequiresResponse$ = this.paymentService.listRetailDisputes(
      merchantId,
      '',
      25,
      disputeStatusToApi(DisputeStatus.NEEDS_RESPONSE),
    );
    const requiresResponse$ = this.paymentService.listRetailDisputes(
      merchantId,
      '',
      25,
      disputeStatusToApi(DisputeStatus.WARNING_NEEDS_RESPONSE),
    );

    return combineLatest([inquiryRequiresResponse$, requiresResponse$]).pipe(
      map(([inquiryRequiresResponse, requiresResponse]) => {
        return {
          countRequiresResponse: inquiryRequiresResponse?.results?.length || 0,
          countInquiryRequiresResponse: requiresResponse?.results?.length || 0,
        };
      }),
    );
  }
}
